<template>
    <div>
        <Head :title="`${form.name}`"/>
        <div class="flex justify-start mb-8 max-w-3xl">
            <h1 class="text-3xl font-bold">
                <Link class="text-indigo-400 hover:text-indigo-600" href="/brands">Brands</Link>
                <span class="text-indigo-400 font-medium">/</span>
                {{ form.name }}
            </h1>
        </div>
        <div class="w-full bg-white rounded-md shadow overflow-hidden">
            <form @submit.prevent="update">
                <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                    <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-1/2"
                                label="Brand name"/>
                    <text-input v-model="form.domain_frontend" :error="form.errors.domain_frontend"
                                class="pb-8 pr-6 w-full lg:w-1/2" label="Frontend domain"/>
                    <text-input v-model="form.locale" :error="form.errors.locale" class="pb-8 pr-6 w-full lg:w-1/2"
                                label="Default locale"/>
                    <text-input v-model="form.domain_backend" :error="form.errors.domain_backend"
                                class="pb-8 pr-6 w-full lg:w-1/2" label="Backend domain"/>
                    <text-input v-model="form.timezone" :error="form.errors.timezone" class="pb-8 pr-6 w-full lg:w-1/3"
                                label="Timezone"/>
                    <text-input v-model="form.token" :error="form.errors.token" class="pb-8 pr-6 w-full lg:w-2/3"
                                label="Access token"/>
                    <multiple-select-input :model-value="form.locales" v-model="form.locales"
                                           :error="form.errors.timezone" class="pb-8 pr-6 w-full"
                                           label="Available locales">
                        <option value="en">EN</option>
                        <option value="de">DE</option>
                    </multiple-select-input>
                    <!--                    <textarea-input v-model="form.meta" :rows="20" :error="form.errors.meta"-->
                    <!--                                    class="pb-8 pr-6 w-full lg:w-1/2" label="Meta data"></textarea-input>-->
                    <!--            <textarea-input v-model="form.options" :rows="20" :error="form.errors.options"  class="pb-8 pr-6 w-full lg:w-1/2" label="Options data"></textarea-input>-->
                    <h5>MGMT credentials</h5>
                    <Vue3JsonEditor
                        v-model="form.mgmt_credentials"
                        :show-btns="false"
                        :expandedOnStart="true"
                        style="width: 100%"
                        @json-change="onChangeMgmtCredentials"/>
                    <h5>Upsell credentials</h5>
                    <Vue3JsonEditor
                        v-model="form.upsell_credentials"
                        :show-btns="false"
                        :expandedOnStart="true"
                        style="width: 100%"
                        @json-change="onChangeUpsellCredentials"/>
                    <h5>Girls Profiles Categories</h5>
                    <Vue3JsonEditor
                        v-model="form.profile_categories"
                        :show-btns="false"
                        :expandedOnStart="true"
                        style="width: 100%"
                        @json-change="onChangeProfilesCategories"/>
                    <h5>Meta data</h5>
                    <Vue3JsonEditor
                        v-model="form.meta"
                        :show-btns="false"
                        :expandedOnStart="true"
                        style="width: 100%"
                        @json-change="onChangeMeta"/>
                    <h5>Options</h5>
                    <Vue3JsonEditor
                        v-model="form.options"
                        :show-btns="false"
                        :expandedOnStart="true"
                        style="width: 100%"
                        @json-change="onChangeOptions"
                    />

                    <textarea-input v-model="form.support_message" :rows="20" :error="form.errors.support_message"
                                    class="pb-8 pr-6 w-full" label="Support message"></textarea-input>

                    <text-input v-model="form.support_girl_firstname" :error="form.errors.support_girl_firstname"
                                class="pb-8 pr-6 w-full" label="Support girl firstname"/>
                    <text-input v-model="form.support_girl_lastname" :error="form.errors.support_girl_lastname"
                                class="pb-8 pr-6 w-full" label="Support girl lastname"/>

                    <div class="flex items-center px-6 py-4 focus:text-indigo-500">
                        <img :src="form.support_girl_image" style="width: 200px">
                    </div>


                    <h5>Auto action intervals</h5>
                    <Vue3JsonEditor
                        v-model="form.intervals"
                        :show-btns="false"
                        :expandedOnStart="true"
                        style="width: 100%"
                        @json-change="onChangeIntervals"
                    />

                    <h5>Auto action limits</h5>
                    <Vue3JsonEditor
                        v-model="form.action_limits"
                        :show-btns="false"
                        :expandedOnStart="true"
                        style="width: 100%"
                        @json-change="onChangeActionLimits"
                    />

                    <h5>Auto action notification limits</h5>
                    <Vue3JsonEditor
                        v-model="form.notifications_limits"
                        :show-btns="false"
                        :expandedOnStart="true"
                        style="width: 100%"
                        @json-change="onChangeActionNotificationLimits"
                    />

                    <h5>Auto action start delay</h5>
                    <Vue3JsonEditor
                        v-model="form.start_delay"
                        :show-btns="false"
                        :expandedOnStart="true"
                        style="width: 100%"
                        @json-change="onChangeActionStartDelay"
                    />

                    <text-input v-model="form.total_duration" :error="form.errors.total_duration"
                                class="pb-8 pr-6 w-full lg:w-1/2" label="Total auto action duration"/>

                    </div>

                <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
                    <Link class="flex items-center px-6 py-4" :href="`/brands/${brand.id}/translations`" tabindex="-1">
                        Translations
                    </Link>
                    <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Update Brand
                    </loading-button>
                </div>
            </form>

                <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                    <label>Support Girl image</label>
                    <file-input v-model="asset.asset" class="pb-8 pr-6 w-full w-full" type="file"/>
                </div>
                <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
                    <loading-button class="btn-indigo ml-auto" type="botton" @click="uploadAsset">Upload asset</loading-button>
                </div>
        </div>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import FileInput from '@/Shared/FileInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import MultipleSelectInput from '@/Shared/MultipleSelectInput'
import TextareaInput from "@/Shared/TextareaInput";

import {Vue3JsonEditor} from 'vue3-json-editor'


export default {
    components: {
        FileInput,
        Head,
        Link,
        LoadingButton,
        SelectInput,
        TextInput,
        MultipleSelectInput,
        TextareaInput,
        Vue3JsonEditor
    },
    layout: Layout,
    props: {
        brand: Object,
        auto_action_settings: Object,
    },
    remember: 'form',
    data() {
        return {
            form: this.$inertia.form({
                name: this.brand.name,
                domain_frontend: this.brand.domain_frontend,
                domain_backend: this.brand.domain_backend,
                timezone: this.brand.timezone,
                locale: this.brand.locale,
                locales: this.brand.locales,
                meta: this.brand.meta,
                options: this.brand.options,
                mgmt_credentials: this.brand.mgmt_credentials,
                upsell_credentials: this.brand.upsell_credentials,
                profile_categories: this.brand.profile_categories,
                token: this.brand.token,
                support_message: this.brand.support_message,
                support_girl_firstname: this.brand.support_girl_firstname,
                support_girl_lastname: this.brand.support_girl_lastname,
                intervals: this.auto_action_settings.intervals,
                action_limits: this.auto_action_settings.action_limits,
                notifications_limits: this.auto_action_settings.notifications_limits,
                total_duration: this.auto_action_settings.total_duration,
                start_delay: this.auto_action_settings.start_delay,
            }),

            asset: this.$inertia.form({
                brand_id: this.brand.id,
                asset: null,
            })
        }
    },
    methods: {
        update() {
            this.form.post(`/brands/${this.brand.id}`, {
                onSuccess: () => this.form.reset('password', 'photo'),
            })
        },
        onChangeIntervals(value) {
            this.form.intervals = value;
        },
        onChangeActionLimits(value) {
            this.form.action_limits = value;
        },
        onChangeActionNotificationLimits(value) {
            this.form.notifications_limits = value;
        },
        onChangeActionStartDelay(value) {
            this.form.start_delay = value;
        },
        onChangeOptions(value) {
            this.form.options = value;
        },
        onChangeMeta(value) {
            this.form.meta = value;
        },
        onChangeMgmtCredentials(value) {
            this.form.mgmt_credentials = value;
        },
        onChangeUpsellCredentials(value) {
            this.form.upsell_credentials = value;
        },
        onChangeProfilesCategories(value) {
            this.form.profile_categories = value;
        }
        ,
        uploadAsset() {
            this.asset.post('/brands/upload-asset', {
                onSuccess: () => this.form.reset('asset'),
            })
        }
    },
}
</script>
